import styled, { css } from 'styled-components';
import { Link } from 'gatsby';

interface IBorderLink {
  color?: string;
}

export const BorderLinkStyle = css<IBorderLink>`
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.blue}!important;
  position: relative;
  line-height: 145% !important;
  white-space: nowrap;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0%;
    bottom: 0px;
    background: ${(props) =>
      props.color ? props.color : props.theme.colors.blue};
    height: 1px;
    transition: right 0.4s ease-out;
  }

  &:hover {
    &:before {
      right: 100%;
    }
  }
`;

export const BorderLink = styled(Link)`
  ${BorderLinkStyle}
`;

export const BorderLinkOut = styled.a`
  ${BorderLinkStyle}
`;
